import CreateColumn from '../../../../Services/agGrid/createColumn';

export const getColumnDefs1 = (props) => {
  return [
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      maxWidth: 100,
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow1,
        gridRef: props.gridRef1,
        rowData: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef,
        lastCheckedIndexRef: props.lastCheckedIndexRef,
        handleRowSelection: props.handleRowSelection,
      },
    }),

    CreateColumn('eduNm', '교육명', 'left', 150, true, false, false, 'text', {
      minWidth: 150,
      maxLength: 100,
    }),

    {
      headerName: '상반기',
      headerClass: 'header-align-center',
      children: [
        {
          headerName: '1분기',
          headerClass: 'header-align-center',
          children: [
            CreateColumn(
              'oneM',
              '1월',
              'left',
              80,
              true,
              false,
              false,
              'text',
              { maxLength: 100 }
            ),
            CreateColumn(
              'twoM',
              '2월',
              'left',
              80,
              true,
              false,
              false,
              'text',
              { maxLength: 100 }
            ),
            CreateColumn(
              'threeM',
              '3월',
              'left',
              80,
              true,
              false,
              false,
              'text',
              { maxLength: 100 }
            ),
          ],
        },
        {
          headerName: '2분기',
          headerClass: 'header-align-center',
          children: [
            CreateColumn(
              'fourM',
              '4월',
              'left',
              80,
              true,
              false,
              false,
              'text',
              { maxLength: 100 }
            ),
            CreateColumn(
              'fiveM',
              '5월',
              'left',
              80,
              true,
              false,
              false,
              'text',
              { maxLength: 100 }
            ),
            CreateColumn(
              'sixM',
              '6월',
              'left',
              80,
              true,
              false,
              false,
              'text',
              { maxLength: 100 }
            ),
          ],
        },
      ],
    },

    {
      headerName: '하반기',
      headerClass: 'header-align-center',
      children: [
        {
          headerName: '3분기',
          headerClass: 'header-align-center',
          children: [
            CreateColumn(
              'sevenM',
              '7월',
              'left',
              80,
              true,
              false,
              false,
              'text',
              { maxLength: 100 }
            ),
            CreateColumn(
              'eightM',
              '8월',
              'left',
              80,
              true,
              false,
              false,
              'text',
              { maxLength: 100 }
            ),
            CreateColumn(
              'nineM',
              '9월',
              'left',
              80,
              true,
              false,
              false,
              'text',
              { maxLength: 100 }
            ),
          ],
        },
        {
          headerName: '4분기',
          headerClass: 'header-align-center',
          children: [
            CreateColumn(
              'tenM',
              '10월',
              'left',
              80,
              true,
              false,
              false,
              'text',
              { maxLength: 100 }
            ),
            CreateColumn(
              'elevenM',
              '11월',
              'left',
              80,
              true,
              false,
              false,
              'text',
              { maxLength: 100 }
            ),
            CreateColumn(
              'twelveM',
              '12월',
              'left',
              80,
              true,
              false,
              false,
              'text',
              { maxLength: 100 }
            ),
          ],
        },
      ],
    },
  ];
};

const columnDefs = {
  getColumnDefs1,
};

export default columnDefs;
